var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{staticClass:"menuDrawerStyle",attrs:{"tabindex":"-1","temporary":"","fixed":""},model:{value:(_vm.MenuDrawer),callback:function ($$v) {_vm.MenuDrawer=$$v},expression:"MenuDrawer"}},[_c('div',{staticClass:"drawer-container menudrawerBackground"},[_c('menu-drawer-menu')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }